import Image from 'app/Components/Shared/Image/image';
import React, { useState } from 'react';
import { isMobile } from 'react-device-detect';
import SwiperCore, { Autoplay, EffectFade, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { prepareNewWindowUrl } from '../../../utilities/StringHelpers/StringHelpers';
import 'swiper/swiper.scss';
import Config from '../../../Config';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import { createReportUpgradeCellularDeviceOrderPage } from '../../../utilities/reports/createReport';

SwiperCore.use([Autoplay, Navigation, EffectFade]);

const UpgradeCellularDeviceSwiperDesktop = (props) => {
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className='upgrade-cellular-device-swiper-container'>
      <Swiper
        navigation={props?.upgradeCellularDeviceObj?.items.length < 5 ? false : true}
        slidesPerView={isMobile ? 2 : 4}
        spaceBetween={22}
        onSwiper={(swiper) => {
          setSwiperInstance(swiper);
        }}
        effect='slide'
        onSlideChange={(swiper) => {
          setActiveIndex(swiper?.activeIndex);
        }}>
        {props.upgradeCellularDeviceObj?.items.map((item, i) => (
          <SwiperSlide key={i} className='slideDesign'>
            <div className='borderImageDesktop'>
              <Image src={Config.epiBaseUrl + item?.image?.value?.url} className='imageContainer' />
            </div>
            <div className='infoData'>
              <div className='description'>
                <span>{item?.description?.value}</span>
              </div>
              <div className='linkDetails'>
                <a onClick={() => {
                  prepareNewWindowUrl(item?.linkDetails?.value, props.context),
                    createReportUpgradeCellularDeviceOrderPage('Info Link Clicked', item.description?.value)
                }}>
                  {props?.upgradeCellularDeviceObj?.linkDetailsString}
                </a>
                <div className='leftArrowDetails'></div>
              </div>
            </div>
            <BtnSubmit
              className='btn-purchase'
              onclick={() => {
                props.setShowPopUp(true),
                  props.setItemInfo(item),
                  props.setIsWorkOrderSucceeded(''),
                  createReportUpgradeCellularDeviceOrderPage('Device Order Button Clicked', item.description?.value)
              }}
              text='להזמנה'
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default UpgradeCellularDeviceSwiperDesktop;
